export const releaseInfo =
 {
 	branch: "beta",
 	lastCommit: "05/18/2025 13:36:16",
 	lastTag: "v6.0.0",
 	buildType: "local",
 	company: "Pinnacle Power Services",
 	user: "dmorr",
 	compileTime: "05/22/2025 09:46:27"
 }
